module.exports = __webpack_public_path__ + "img/songfeng.7e82cf18.png";